export default __webpack_public_path__ + "images/svg-sprite/sdss-linkfire.svg";